import React from 'react';
import { useSelector } from 'react-redux';

import { formatPrice } from '~/util/format';
import CardHeader from '../SecondaryPanelCard/CardHeader';
import ChallengeProgress from './ChallengeProgress';

import * as Style from './styles';

function ChallengePanelCard({
    totalSalesValue,
    quotaLabel,
    currentQuotaValue,
    salesPercentage,
}) {
    const userProfile = useSelector(state => state.user.profile);

    const firstName = userProfile?.nome?.split(' ')[0]?.toLowerCase() || '';
    const formattedTotalSalesValue = formatPrice(totalSalesValue);

    const hasExceededChallenge = Number(salesPercentage) >= 100;

    return (
        <Style.PanelCardContainer>
            <CardHeader
                cardTitle="Desafio"
                totalValue={formattedTotalSalesValue}
            />

            {hasExceededChallenge && (
                <Style.CongratulationsText>
                    Parabéns, {firstName}!
                </Style.CongratulationsText>
            )}

            <ChallengeProgress
                quotaLabel={quotaLabel}
                currentQuotaValue={currentQuotaValue}
                salesPercentage={salesPercentage}
                totalSalesValue={totalSalesValue}
            />
        </Style.PanelCardContainer>
    );
}

export default ChallengePanelCard;
